import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Typography, notification, Dropdown, Menu, Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
  faTrash,
  faCheckDouble,
  faCheck,
  faThumbsDown,
  faThumbsUp,
  faEllipsis,
  faInfoCircle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import Loading from "../../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  detailChangeReadStatus,
  detailChangeStatus,
  detailDeleteNotification,
} from "../../../controllers/V1/notificationController";
import { usePermissions } from "../../../controllers/PermissionContext";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { formatProjectDate } from "../../../controllers/common";
const NotificationDetails = ({ popUpOpen, setDetailsList, detailsList }) => {
  const PERMISSION = usePermissions("notification");
  const handleCancel = () => {
    setDetailsList();
  };
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeReadStatus = async (id, status) => {
    try {
      setIsLoading(true);
      const options = {
        id: id,
        status: status === "Y" ? "N" : "Y",
      };
      const res = await detailChangeReadStatus(options);
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Read status changed successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something when wrong! Please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
      handleCancel();
    }
  };

  const handleChangeStatus = async (id, status) => {
    try {
      setIsLoading(true);
      const options = {
        id: id,
        status: status === "A" ? "I" : "A",
      };
      const res = await detailChangeStatus(options);
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Status changed successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something when wrong! Please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
      handleCancel();
    }
  };
  const confirmDeleteNotification = (id) => {
    Modal.confirm({
      title: "Delete Notification",
      content:
        "Are you sure you want to delete this notification? This action cannot be undone.",
      okText: "Yes, Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () => handleDeleteNotification(id),
    });
  };

  const handleDeleteNotification = async (id) => {
    try {
      setIsLoading(true);
      const options = {
        id: id,
      };
      const res = await detailDeleteNotification(options);
      if (res?.status === true) {
        notification.open({
          message: "Success",
          description: `Notification deleted successfully.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "green" }} icon={faCheckCircle} />
          ),
          duration: 2,
        });
      }
    } catch (error) {
      setIsLoading(false);
      notification.open({
        message: "Oops!",
        description: `Something when wrong! Please try again.`,
        placement: "topRight",
        icon: <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />,
        duration: 2,
      });
    } finally {
      setIsLoading(false);
      handleCancel();
    }
  };
  console.log("detailsList : ", detailsList);
  return (
    <Dialog
      open={popUpOpen}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"xl"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="myDrawer">
          <div className="inventory_popup_title">
            <Typography
              variant="h5"
              component="div"
              gutterBottom
              className="inventory_popup_title_heading"
            >
              Notification Details
            </Typography>
            <Link
              to={false}
              style={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#dd5151",
              }}
              onClick={handleCancel}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </Link>
          </div>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          ></Typography>

          <Typography
            variant="body1"
            component="div"
            className="my_delete_popup_paragraph"
          >
            <div>
              <div id="content-wrapper" className="d-flex flex-column">
                <div className="card shadow mb-4">
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                      <table
                        className="table table-bordered"
                        id="dataTable"
                        width="100%"
                        cellspacing="0"
                      >
                        <thead>
                          <tr>
                            <th>Sl. No.</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Created At</th>
                            {(PERMISSION?.fullAccess === "Y" ||
                              PERMISSION?.send === "Y" ||
                              PERMISSION?.change_read_status === "Y" ||
                              PERMISSION?.change_status === "Y" ||
                              PERMISSION?.delete === "Y") && <th>Action</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {detailsList?.length > 0 ? (
                            detailsList.map((items, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {items?.userType === "Admin" && (
                                      `${items?.users_id?.admin_first_name} ${items?.users_id?.admin_last_name}`
                                    )}

                                    {items?.userType === "Agent" && (
                                      `${items?.users_id?.first_name} ${items?.users_id?.last_name}`
                                    )}

                                    {items?.userType === "Users" && (
                                      `${items?.users_id?.users_name} ${items?.users_id?.last_name}`
                                    )}

                                  </td>
                                  <td>{items?.userType || items?.users_id?.users_type}</td>
                                  <td>{items?.title || "-"}</td>
                                  <td>{items?.description || "-"}</td>
                                  <td>{items?.status || "-"}</td>
                                  <td>{formatProjectDate(items?.createdAt)}</td>
                                  {(PERMISSION?.fullAccess === "Y" ||
                                    PERMISSION?.send === "Y" ||
                                    PERMISSION?.change_read_status === "Y" ||
                                    PERMISSION?.change_status === "Y" ||
                                    PERMISSION?.delete === "Y") && (
                                    <td onClick={(e) => e.stopPropagation()}>
                                      {items?.status !== "D" ? (
                                        <Dropdown
                                          overlay={
                                            <Menu>
                                              {(PERMISSION?.delete === "Y" ||
                                                PERMISSION?.fullAccess ===
                                                  "Y") && (
                                                <Menu.Item
                                                  key={`01`}
                                                  onClick={() =>
                                                    confirmDeleteNotification(
                                                      items?._id
                                                    )
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faTrash}
                                                  />{" "}
                                                  <span className="show_span">
                                                    Delete
                                                  </span>
                                                </Menu.Item>
                                              )}

                                              {(PERMISSION?.change_read_status ===
                                                "Y" ||
                                                PERMISSION?.fullAccess ===
                                                  "Y") &&
                                                items?.is_read === "N" &&
                                                items?.status === "A" && (
                                                  <Menu.Item
                                                    key={`02`}
                                                    onClick={() =>
                                                      handleChangeReadStatus(
                                                        items?._id,
                                                        "N"
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faCheckDouble}
                                                    />{" "}
                                                    <span className="show_span">
                                                      Mark As Read
                                                    </span>
                                                  </Menu.Item>
                                                )}

                                              {(PERMISSION?.change_read_status ===
                                                "Y" ||
                                                PERMISSION?.fullAccess ===
                                                  "Y") &&
                                                items?.is_read === "Y" &&
                                                items?.status === "A" && (
                                                  <Menu.Item
                                                    key={`03`}
                                                    onClick={() =>
                                                      handleChangeReadStatus(
                                                        items?._id,
                                                        "Y"
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faCheck}
                                                    />{" "}
                                                    <span className="show_span">
                                                      Mark As Unread
                                                    </span>
                                                  </Menu.Item>
                                                )}

                                              {(PERMISSION?.change_status ===
                                                "Y" ||
                                                PERMISSION?.fullAccess ===
                                                  "Y") &&
                                                items?.status === "A" && (
                                                  <Menu.Item
                                                    key={`04`}
                                                    onClick={() =>
                                                      handleChangeStatus(
                                                        items?._id,
                                                        items?.status
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faThumbsDown}
                                                    />{" "}
                                                    <span className="show_span">
                                                      Inactive
                                                    </span>
                                                  </Menu.Item>
                                                )}

                                              {(PERMISSION?.change_status ===
                                                "Y" ||
                                                PERMISSION?.fullAccess ===
                                                  "Y") &&
                                                items?.status === "I" && (
                                                  <Menu.Item
                                                    key={`05`}
                                                    onClick={() =>
                                                      handleChangeStatus(
                                                        items?._id,
                                                        items?.status
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faThumbsUp}
                                                    />{" "}
                                                    <span className="show_span">
                                                      Active
                                                    </span>
                                                  </Menu.Item>
                                                )}
                                            </Menu>
                                          }
                                          placement="bottomLeft"
                                          arrow
                                          overlayStyle={{ zIndex: 9999 }}
                                        >
                                          <FontAwesomeIcon icon={faEllipsis} />
                                        </Dropdown>
                                      ) : (
                                        "--"
                                      )}
                                    </td>
                                  )}
                                </tr>
                              </>
                            ))
                          ) : isLoading ? (
                            <SkeltonList row={5} col={6} />
                          ) : (
                            <tr>
                              <td colspan="9" className="img-center">
                                No data found !
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Typography>
        </div>
      </div>
      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default NotificationDetails;
